import setItemsFlagStateFromNodeIds from '../actions/actionCreators/setItemsFlagStateBasedOnNodeIds';
import { setItemsFlagStateFromItemIds } from '../actions/setItemsFlagState';
import getItemIdsToShowFromNodeIds from 'owa-mail-store/lib/selectors/getItemIdsToShowFromNodeIds';
import { orchestrator } from 'satcheljs';

export default orchestrator(setItemsFlagStateFromNodeIds, actionMessage => {
    const itemIds = getItemIdsToShowFromNodeIds(actionMessage.nodeIds);

    setItemsFlagStateFromItemIds(
        itemIds,
        null,
        { FlagStatus: actionMessage.flagStatusToSet },
        actionMessage.tableViewId,
        actionMessage.actionSource
    );
});
